// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1VCKf","hiddenElements":"Header_hiddenElements__2z25Q","search":"Header_search__ckDys","dark":"Header_dark__1zK7_","wrapper":"Header_wrapper__4Axjt"};